import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { IEntityAppointment } from './typings'
import { getAllEntityAppointments, getAppointment } from './api'
import { filterByEntity } from '@sales-center/common'

const entityAppointmentAdapter = createEntityAdapter<IEntityAppointment>({
  selectId: (b) => b.appointmentId,
  sortComparer: (a, b) => {
    const aTime = a.workTime?.getTime() ?? 0
    const bTime = b.workTime?.getTime() ?? 0
    return aTime - bTime
  },
})

export const initialState = entityAppointmentAdapter.getInitialState()

const entityAppointments = createSlice({
  name: 'entityAppointments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getAllEntityAppointments.fulfilled,
      (state, { payload, meta }) => {
        // remove any that may have been deleted
        const { entityId, entityType } = meta.arg

        const del = filterByEntity(
          localSelectors.selectAll(state),
          entityId,
          entityType,
        ).map((a) => a.appointmentId)

        entityAppointmentAdapter.removeMany(state, del)

        entityAppointmentAdapter.upsertMany(state, payload)
      },
    )

    builder.addCase(getAppointment.fulfilled, (state, { payload }) => {
      if (payload.appointmentId)
        entityAppointmentAdapter.upsertOne(state, payload)
    })
  },
})

export default entityAppointments.reducer

const localSelectors = entityAppointmentAdapter.getSelectors()

const selectors = entityAppointmentAdapter.getSelectors<StoreData>(
  (state) => state.entityAppointments,
)

export const { selectAll: selectAllEntityAppointments } = selectors
